import siteButtonTheme from './siteButtonTheme';

const siteButtonDarkTheme = {
    button: {
        ...siteButtonTheme,
    },
};

export default siteButtonDarkTheme;
